import { DateTime } from 'luxon';

export const formatDate = (timestamp: string): string => {
  const date = DateTime.fromISO(timestamp);
  return date.toLocaleString(DateTime.DATETIME_SHORT);
};
